export default {
    0: 'main.cars',
    1: 'main.flights.roundtrip',
    2: 'main.hotels',
    3: 'main.trains.roundtrip',
    4: 'main.ukrail',
};




// WEBPACK FOOTER //
// ./src/app/modules/trip/config/statesMap.constant.js